module.exports = __webpack_public_path__ + "static/img/allef-vinicius-6ypOmTNK2FA-unsplash_thumb.abd0ea5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/allef-vinicius-6ypOmTNK2FA-unsplash_thumb.png
// module id = UpoU
// module chunks = 4